import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-carousel-fluid',
  templateUrl: './carousel-fluid.component.html',
  styleUrls: ['./carousel-fluid.component.scss']
})

export class CarouselFluidComponent {
  @Input() listCarousel = [];
  @Output() openModal: EventEmitter<{ index: number }> = new EventEmitter<{ index: number }>();
  @ViewChildren('image') refListItem: QueryList<ElementRef>;
  @ViewChild('list') refList: ElementRef;
  position = 0;
  scrolling: ReturnType<typeof setTimeout>;
  isShifting: ReturnType<typeof setTimeout>;
  hasScroll = true;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: string) { }

  handleNavigationButton(direction: number) {
    this.handleShift(direction);
    window.clearTimeout(this.isShifting);
    this.isShifting = setTimeout(() => {
      this.scrollToImage(this.position);
    }, 100);
  }

  handleScroll(event: WheelEvent) {
    window.clearTimeout(this.scrolling);
    this.scrolling = setTimeout(() => {
      this.setNewCurrentImageByCoordinate(event.x, event.y);
    }, 150);
  }

  handleOpenModal(position: number) {
    this.openModal.emit({ index: position });
  }

  handleShift(shiftValue: number) {
    const nextPosition: number = this.position + shiftValue;
    this.updatePosition(nextPosition);
  }

  setNewCurrentImageByCoordinate(x: number, y: number) {
    const element: Element = document.elementFromPoint(x, y);
    const parsedIndex = this.getElementIndex(element);
    return this.updatePosition(parsedIndex);
  }

  getElementIndex(element: Element) {
    const elementIndex = element.id.split('-');
    return parseInt(elementIndex[elementIndex.length - 1], 10);
  }

  scrollToImage(position: number) {
    const imageList = this.refListItem.toArray();
    imageList[position].nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  setScroll(element: Element) {
    if (isPlatformBrowser(this.platformId)) {
      this.hasScroll = element.getBoundingClientRect().width !== element.scrollWidth;
    }
  }

  updatePosition(nextPosition: number) {
    if (nextPosition < this.refListItem.toArray().length && nextPosition >= 0) {
      if (this.position === 0 && this.refListItem.toArray()[0].nativeElement.offsetWidth < this.refList.nativeElement.offsetWidth / 2) {
        this.position = nextPosition + 1;
        return true;
      }
      if (this.position === this.refListItem.toArray().length - 1 && this.refListItem.toArray()[this.refListItem.toArray().length - 1].nativeElement.offsetWidth < this.refList.nativeElement.offsetWidth / 2) {
        this.position = nextPosition - 1;
        return true;
      }
      this.position = nextPosition;
      return true;
    }
    return false;
  }
}
